import { motion } from "framer-motion";

import { springSnappy } from "../share-session-dialog-constants";

import { cn } from "@/lib/utils";

export const ShareSessionToggleSwitch = ({
  checked,
  onChange,
  disabled = false,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={cn(
      "relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      checked ? "bg-blue-500" : "bg-gray-200 dark:bg-gray-700",
      disabled && "cursor-not-allowed opacity-40",
    )}
  >
    <motion.span
      layout
      transition={springSnappy}
      className={cn(
        "pointer-events-none block h-3.5 w-3.5 rounded-full bg-white shadow-sm ring-0",
        checked ? "ml-[18px]" : "ml-[3px]",
      )}
    />
  </button>
);
